var render = function render(){var _vm=this,_c=_vm._self._c;return _c('edit-role',{attrs:{"come-from":"update","updating-name":_vm.name,"permissions":_vm.permissions,"app-loading":_vm.appLoading},on:{"submit":_vm.editRole}})
}
var staticRenderFns = []

export { render, staticRenderFns }